import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import VueGtm from 'vue-gtm'
import VueGtag from 'vue-gtag'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/survey-page',
    name: 'SurveyPage',
    component: () => import('../views/SurveyPage.vue')
  },
  {
    path: '/appreciate',
    name: 'Appreciate',
    component: () => import('../views/Appreciate.vue')
  }
]

const router = new VueRouter({
  routes
})
Vue.use(VueGtag, {
  config: { id: 'UA-849994-6' }
}, router)

Vue.use(VueGtm, {
  id: 'GTM-WDCQ8LQ'
})

export default router
